import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AfterContentInit, AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/services/auth.service';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { SharedService } from 'src/app/services/shared.service';
import { getCurriculumCompletion } from 'src/app/store/actions/account.action';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { getStudentLatestAssessment, getStudentSchedule } from 'src/app/store/actions/student.action';
import { AppState } from 'src/app/store/app.state';
import { getLatestEnrollmentStatus, getStudentApplication } from 'src/app/store/selectors/account.selector';

@Component({
  selector: 'app-student-layout',
  templateUrl: './student-layout.component.html',
  styleUrls: ['./student-layout.component.scss']
})
export class StudentLayoutComponent implements OnInit, AfterViewInit  {

  getStudenApplication$: Observable<any>;
  studentApplication: any;

  getLatestEnrollmentStatus$: Observable<any>;
  latestEnrollmentStatus: any;

  userProfile: any;

  ngUnsubscribe = new Subject<void>();

  schoolOpen: Boolean = false;
  schoolAbout: Boolean = false;
  schoolCalendar: Boolean = false;
  schoolFacilities: Boolean = false;
  curriculumOpen: Boolean = false;
  financeOpen: Boolean = false;
  SchemesOpen: Boolean = false;
  adminOpen: Boolean = false;
  registrarOpen: Boolean = false;

  activeStepIndex = 0;

  applicationCompleted = false;
  preEnrollmentCompleted = false;
  firstInterviewCompleted = false;
  academicReqCompleted = false;
  secondInterviewCompleted = false;
  LOACompleted = false;
  enrollmentCompleted = false;

  @ViewChild('sidenav') sidenav!: MatSidenav;

  currentUrl: any;

  admission_types = ['F', 'T', 'D', 'SH']

  constructor(
    private store: Store<AppState>,
    private sharedService: SharedService,
    public router: Router,
    private authService: AuthService,
    private offlineStorageService: OfflineStorageService,
    private cdr: ChangeDetectorRef,
    private accountService: AccountService,
    private observer: BreakpointObserver
  ) { 
    this.getStudenApplication$ = this.store.select(getStudentApplication);
    this.getLatestEnrollmentStatus$ = this.store.select(getLatestEnrollmentStatus);
  }

  async ngOnInit() {
    this.getLatestEnrollmentStatus$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.latestEnrollmentStatus = res;
        console.log(this.latestEnrollmentStatus);
      }
    })

    this.getStudenApplication$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.studentApplication = res;
        console.log({studentApplication: this.studentApplication})
        this.checkStatus();
        // this.accountService.checkStatus(this.studentApplication)
      }
    });
    
    this.sharedService.sidenavToggle$.subscribe(() => {
      this.sidenav.toggle();
    });

    const user = await this.offlineStorageService.getObject('user');
    this.userProfile = JSON.parse(user);
  }

  ngAfterViewInit() {
    this.observer.observe(['(max-width: 768px)']).subscribe(result => {
      if (result.matches) {
        this.sidenav.mode = 'over';
        this.sidenav.close();
        this.cdr.detectChanges();
      } else {
        this.sidenav.mode = 'side';
        this.sidenav.open();
        this.cdr.detectChanges();
      }
    });
  }

  logout(){
    this.store.dispatch(setLoadingSpinner({status: true}))
    this.authService.autoLogout();
  }

  getImg(name){
    return `assets/img/sidenav/${name}.svg`
  }

  changeStep(step: number) {
    this.activeStepIndex = step;
  }

  isApplicationExpanded(): boolean {
    const appRoutes = [
      '/student/application-form-college',
      '/student/application-form-senior-high',
      '/student/undergraduate-form',
      '/student/pre-enrollment',
      '/student/first-interview',
      '/student/academic-requirements',
      '/student/second-interview',
      '/student/loa'
    ];
    return appRoutes.includes(this.router.url) || !this.studentApplication;
  }

  checkStatus(){
    if(this.studentApplication?.details?.notes?.length > 0){
      const notes = this.accountService.getLatestNote(this.studentApplication?.details?.notes);
      console.log(notes);
      if(notes?.status == 'new'){
        console.log('pre_enrollment_requirements');
        this.applicationCompleted = true;
        this.changeStep(1);
      }
      else if(notes?.status == 'pre_enrollment_requirements'){
        console.log('pre_enrollment_requirements');
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.changeStep(2);
      } 
      else if(notes?.status == 'first_interview_scheduled'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.changeStep(2);
      } 
      else if(notes?.status == 'first_interview_scheduled_failed'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.changeStep(2);
      } 
      else if(notes?.status == 'first_interview_scheduled_passed'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.firstInterviewCompleted = true;
        this.changeStep(3);
      }
      else if(notes?.status == 'academic_requirements'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.firstInterviewCompleted = true;
        this.academicReqCompleted = true;
        this.changeStep(4);
      } 
      else if(notes?.status == 'second_interview_scheduled'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.firstInterviewCompleted = true;
        this.academicReqCompleted = true;
        this.changeStep(4);
      } 
      else if(notes?.status == 'second_interview_scheduled_failed'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.firstInterviewCompleted = true;
        this.academicReqCompleted = true;
        this.changeStep(4);
      } 
      else if(notes?.status == 'second_interview_scheduled_passed'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.firstInterviewCompleted = true;
        this.academicReqCompleted = true;
        this.secondInterviewCompleted = true;
        this.changeStep(5);
      } 
      else if(notes?.status == 'await_loa'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.firstInterviewCompleted = true;
        this.academicReqCompleted = true;
        this.secondInterviewCompleted = true;
        this.changeStep(5);
      } 
      else if(notes?.status == 'sent_loa'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.firstInterviewCompleted = true;
        this.academicReqCompleted = true;
        this.secondInterviewCompleted = true;
        this.LOACompleted = true;
        this.changeStep(5);
      } 
      else if(notes?.status == 'complete'){
        this.applicationCompleted = true;
        this.preEnrollmentCompleted = true;
        this.firstInterviewCompleted = true;
        this.academicReqCompleted = true;
        this.secondInterviewCompleted = true;
        this.LOACompleted = true;
        this.enrollmentCompleted = true;
        this.changeStep(6);
      }
    }
  }

  goToAdmission(){
    const pre_enlistment = this.latestEnrollmentStatus?.pre_enlistments;
    if(pre_enlistment){
      if(pre_enlistment?.preenlistment_status == 'submitted'){
        this.router.navigateByUrl('/student/undergraduate-clearance')
      } else if(pre_enlistment?.preenlistment_status == 'blocked'){
        this.router.navigateByUrl('/student/undergraduate-clearance')
      } else if(pre_enlistment?.preenlistment_status == 'cleared'){
        this.router.navigateByUrl('/student/undergraduate-clearance')
      }
    } else if(!pre_enlistment && !this.admission_types.includes(this.userProfile?.student?.admission_type)){
      this.router.navigateByUrl('/student/undergraduate-form');
    } else if(!pre_enlistment && this.admission_types.includes(this.userProfile?.student?.admission_type) && this.userProfile?.student?.year_level !== 1){
      this.router.navigateByUrl('/student/undergraduate-form');
    } else{
      this.router.navigateByUrl('/student/welcome');
    }
  }

  getLatestAssessment(){
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(getStudentLatestAssessment({student_id: this.userProfile?.student?.student_id}))
  }

  getStudentSchedule(){
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(getStudentSchedule({student_id: this.userProfile?.student?.student_id, term_id: this.userProfile?.student?.term_id}))
  }

  goToLatestStatus(){
    this.accountService.checkStatus(this.studentApplication?.details?.notes);
  }
  
  viewCurriculumReport() {
    // return console.log(this.latestEnrollmentStatus?.pre_enlistments?.student_id);
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(getCurriculumCompletion({data: this.studentApplication?.user?.student?.student_id}));
  }

  checkAdmissionType(type){
    const newStudentTypes = ['F', 'T', 'D', 'SH'];
    return newStudentTypes?.includes(type);
  }
}
